










import { defineComponent } from '@nuxtjs/composition-api'
import { addBasePath } from '~/helpers/addBasePath';

export default defineComponent({
    setup() {
        const images = [
            {
                url: addBasePath('/resources/solepro/images/payment-icons/visa-logo.png')
            },
            {
                url: addBasePath('/resources/solepro/images/payment-icons/Mastercard.png')
            },
            {
                url: addBasePath('/resources/solepro/images/payment-icons/AMEX.png'),
                bgColor: "#1F72CD",
                classes: 'py-0 px-0'
            },
            {
                url: addBasePath('/resources/solepro/images/payment-icons/PayPal.png'),
                classes: 'py-0 px-0'
            },
            {
                url: addBasePath('/resources/solepro/images/payment-icons/satispay.png')
            },
        ]
        return { images }
    },
})
